import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Elena',
  image: 'https://cdn.magicpatterns.com/uploads/cQGaGkP4jELqw3LDUoGDfs/testimonio_engano_elena_1.png',
  quote: 'Por primera vez entendí que no era amor… era dependencia emocional. Este entrenamiento me ayudó a recuperar tranquilidad.'
}, {
  name: 'Ricardo',
  image: 'https://cdn.magicpatterns.com/uploads/ka7zVpMcMz9nV82VW89e57/ricardo_testimonio_2_.png',
  quote: 'Vivía con ansiedad todos los días. Después de escuchar a Freddy entendí muchas cosas sobre mí y empecé a reconstruirme emocionalmente.'
}, {
  name: 'Carmen',
  image: 'https://cdn.magicpatterns.com/uploads/o9epw3VsD57E5R3kQdjGeB/testimonio_3.png',
  quote: 'Sentía que estaba perdiéndome por alguien. El Método F.O.D.A me hizo abrir los ojos y volver a conectar conmigo.'
}];
export function Testimonials() {
  return <section className="py-24 px-6" data-id="element-155">
      <div className="max-w-6xl mx-auto" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-157">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-158">
            Testimonios
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-159">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-teal-900 p-8 rounded-3xl shadow-sm border border-cream/10 relative flex flex-col" data-id="element-160">
              <div className="flex gap-1 mb-6" data-id="element-161">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-162" />)}
              </div>
              <p className="text-lg text-cream/90 leading-relaxed italic mb-8 flex-grow" data-id="element-163">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-cream/10" data-id="element-164">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-teal-800 ring-2 ring-gold/30 flex-shrink-0" data-id="element-165">
                  <img src={item.image} alt={`Foto de ${item.name}`} className="w-full h-full object-cover" data-id="element-166" />
                </div>
                <div data-id="element-167">
                  <p className="font-serif text-cream text-lg" data-id="element-168">{item.name}</p>
                  <p className="text-cream/50 text-xs uppercase tracking-wider" data-id="element-169">
                    Estudiante del Método F.O.D.A
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}